module.exports = __webpack_public_path__ + "img/lb8.ed1f632b.svg";